import { ContactForm } from '@/components/ContactForm'
import {
  ContentBlocks,
  contentBlocksQuery,
} from '@/components/contentBlocks/ContentBlocks'
import { Hero } from '@/components/Hero'
import { statamicGraphqlEndpoint } from '@/globals/globals'
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  SimpleGrid,
  useDisclosure,
} from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticProps, InferGetStaticPropsType } from 'next'
import { NextSeo } from 'next-seo'
import { useState } from 'react'

export const getStaticProps: GetStaticProps = async () => {
  const data = await request(
    statamicGraphqlEndpoint,
    gql`
      query MyQuery {
        entry(collection: "pages", slug: "contact") {
          title
          id
          ... on Entry_Pages_PageContact {
            id
            heading
            pre_heading
            intro
            ${contentBlocksQuery}
          }
        }
      }
    `
  )

  return {
    props: {
      data: data.entry,
    },
    revalidate: 60,
  }
}

export const Page = (props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [formSlug, setFormSlug] = useState<string | null>(null)

  const supportTypes = [
    {
      buttonText: 'Contact Us',
      buttonOnClick: () => {
        setFormSlug('merch')
        onOpen()
      },
      description: 'Need help with your order? We’re here to help.',
      id: '1',
      title: 'Merch Support',
    },
    {
      buttonText: 'Contact Support',
      buttonOnClick: () => {
        setFormSlug('website')
        onOpen()
      },
      description:
        'Having trouble using our site or with your Deboss Nation account?',
      id: '2',
      title: 'Website Support',
    },
    {
      buttonText: 'Contact Us',
      buttonOnClick: () => {
        setFormSlug('business')
        onOpen()
      },
      description:
        'Looking to advertise with Deboss Garage? Start the conversation here.',
      id: '3',
      title: 'Business Inquiries',
    },
    {
      buttonText: 'Join Deboss Nation',
      buttonOnClick: () => {
        window.location.href = '/membership'
      },
      description: 'Chat with Rich, or ask the Builder community.',
      id: '4',
      title: 'Automotive Questions',
    },
  ]

  return (
    <>
      <NextSeo title='Contact Deboss Garage' />
      <Hero
        label={props.data.title}
        heading={props.data.heading}
        subheading={props.data.intro}
      />
      <Box py={20}>
        <Container maxWidth='7xl' pb={10}>
          <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing={10}>
            {supportTypes.map(item => (
              <Box
                key={item.title}
                textAlign='center'
                backgroundColor='white'
                p={6}>
                <Flex align='center' direction='column' gap={4} height='100%'>
                  <Heading lineHeight={1}>{item.title}</Heading>
                  <Box>{item.description}</Box>
                  <Box mt='auto'>
                    <Button onClick={item.buttonOnClick} variant='dark'>
                      {item.buttonText}
                    </Button>
                  </Box>
                </Flex>
              </Box>
            ))}
          </SimpleGrid>
        </Container>
        <ContentBlocks {...props.data} />
      </Box>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            {formSlug ? <ContactForm formSlug={formSlug} /> : null}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default Page
